<template>
    <div class="container-fluid p-0">
        <div class="bg-container">
            <div class="container">
                <div class="d-block d-md-none my-btn type-2 filtr-button" @click="activeFiltr = !activeFiltr">
                    <span>{{ Lang.get('js.filtres.filtr_button') }}</span>
                </div>
                <div class="all-filtres" :class="{ activeFiltr }">
                    <div class="closeMob d-block d-md-none" @click="activeFiltr = !activeFiltr"></div>
                    <div class="d-block d-md-flex">
                        <div class="cancel-button" v-if="filters.price_sorting || filters.area_from
                        || filters.area_to || filters.price_from ||
                        filters.price_to || filters.district || filters.station
                        || filters.my_type || filters.my_status || status !== 'all'"
                             @click="clearFilters">
                            {{ Lang.get('js.filtres.cancel_filtres') }}
                        </div>
                        <div class="filtrCheck-button">
                            <el-radio v-for="item in premiseTypeOptions" v-model="status"
                                      :key="item.id" :value="item.value" :label="item.value">{{item.value}}
                            </el-radio>
                        </div>

                        <ul class="showcase row list-inline text-center m-0">
                            <li @click="getPremisePages('all')" class="col-auto"
                                :class="setClassActive('all')">{{
                                Lang.get('js.filtres.all_warehouse') }}
                            </li>

<!--                            <li class="search">-->
<!--                                {{ Lang.get('js.filtres.full_search') }}-->
<!--                            </li>-->
                            <button @click="fullSearchShow = true" class="search">
                                {{ Lang.get('js.filtres.full_search') }}
                            </button>
                            <!--                        <li v-if="filters.price_sorting || filters.area_from-->
                            <!--                        || filters.area_to || filters.price_from ||-->
                            <!--                        filters.price_to || filters.district || filters.station-->
                            <!--                        || filters.my_type || filters.my_status || status !== 'all'"-->
                            <!--                        @click="clearFilters">-->
                            <!--                            Сбросить фильтры-->
                            <!--                        </li>-->
                        </ul>

                    </div>
                    <!--                <div class="right type-filtr">-->
                    <!--                    <div class="district-filtr">-->
                    <!--                        <p class="fil-title">{{ Lang.get('js.filtres.type_warehouse') }}</p>-->
                    <!--                        <button v-for="(item,index) in premisesType"-->
                    <!--                                v-model="filters.my_type"-->
                    <!--                                @click="setMyTypeElement(item.id)"-->
                    <!--                                :class="setClassActiveStation(item.name)">{{item.name}}-->
                    <!--                        </button>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <div class="full-research" v-if="fullSearchShow">
                        <!--                    <ul class="sub-showcase p-0 mb-0">-->
                        <!--                        <li class="pl-0" v-for="item in premisesType" @click="getPremisePages(status, item.id)"-->
                        <!--                            :class="item.id == type ? 'active' : ''"><span-->
                        <!--                                class="checkbox"></span>{{item.name}}-->
                        <!--                        </li>-->

                        <!--                    </ul>-->
                        <div class="row">
                            <div class="col-12">
                                <p>{{ Lang.get('js.filtres.sort') }}</p>
                            </div>
                            <div class="top col-12 col-md-6">
                                <div class="sorts sortsPriceFrom">

                                <el-radio v-for="item in preparedPriceOptionsList" v-model="filters.price_sorting" :key="item.id"
                                          :value="item.value" :label="item.value">{{item.label}}
                                </el-radio>
                            </div>
                        </div>
                        <div class="right col-6 metro-filtr recomend">
                            <div class="district-filtr">
                                <el-radio
                                        v-for="(item,index) in premisesStatuses"
                                        v-model="filters.my_status"
                                        :key="item.id"
                                        :value="item.id"
                                        :label="item.id"
                                >
                                    {{item.name}}
                                </el-radio>
                            </div>
                        </div>
                        <div class="right col-12">
                            <div class="district-filtr">
                                <p class="fil-title">{{ Lang.get('js.filtres.fil-title-district') }}</p>
                                <button v-for="(item,index) in districtOptions"
                                        v-model="filters.district"
                                        @click="setDistrictElement(item.id)"
                                        :class="setClassActiveDistrict(item.id)">{{Lang.locale == 'ua' ? item.name_ua : item.name_ru}}
                                </button>
                            </div>
                        </div>
                        <div class="right col-12 metro-filtr">
                            <div class="district-filtr">
                                <p class="fil-title">{{ Lang.get('js.filtres.fil-title-station') }}</p>
                                <button v-for="(item,index) in stationOptions"
                                        v-model="filters.station"
                                        @click="setStationElement(item.id)"
                                        :class="setClassActiveStation(item.id)">{{Lang.locale == 'ua' ? item.name_ua : item.name_ru}}
                                </button>
                            </div>
                        </div>


                            <div class="left col-12 col-md-6">
                                <div class="price">
                                    <div class="row">
                                        <div class="col-6 price-from">
                                            <label class="font-weight-bold">{{ Lang.get('js.filtres.price_from') }}</label>
                                            <input type="text"
                                                   class="form-control"
                                                   name="price"
                                                   v-model="filters.price_from">
                                        </div>
                                        <div class="col-6 price-to">
                                            <label class="font-weight-bold">{{ Lang.get('js.filtres.price_to') }}</label>
                                            <input type="text"
                                                   class="form-control"
                                                   name="price"
                                                   v-model="filters.price_to">
                                        </div>
                                    </div>
                                </div>

                                <div class="">
                                    <div class="district-filtr">
                                        <p class="fil-title">{{ Lang.get('js.filtres.type_warehouse') }}</p>
                                        <button v-for="(item,index) in premisesType"
                                                v-model="filters.my_type"
                                                @click="setMyTypeElement(item.id)"
                                                :class="setClassActiveType(item.id)">{{item.name}}
                                        </button>
                                    </div>
                                </div>

                                <div class="square">
                                    <div class="row">
                                        <div class="col-6 square-from">
                                            <label class="font-weight-bold">{{ Lang.get('js.filtres.square_from') }}</label>
                                            <el-select :placeholder="Lang.get('js.filtres.square_from')"
                                                       v-model="filters.area_from"
                                                       clearable>
                                                <el-option
                                                        v-for="item in areaVariations"
                                                        :key="item.id"
                                                        :label="item.value"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-6 square-to">
                                            <label class="font-weight-bold">{{ Lang.get('js.filtres.square_to') }}</label>
                                            <el-select :placeholder="Lang.get('js.filtres.square_to')"
                                                       v-model="filters.area_to"
                                                       clearable>
                                                <el-option
                                                        v-for="item in areaVariations"
                                                        :key="item.id"
                                                        :label="item.value"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button @click="getPremisePages(this.status); activeFiltr = !activeFiltr" class="sho-result my-btn type-2">{{
                                Lang.get('js.results') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div v-if="Object.keys(data).length > 0" class="row">
                <div v-for="item in data" class="col-sm-6 col-lg-4 catalog-item">
                    <div class="premise-page-preview position-relative">
                        <premise-page-preview :premise-page="item"></premise-page-preview>
                    </div>
                </div>
            </div>
            <i v-else-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success" style="font-size: 15px;"></i>
            <p v-else class="text-center m-0 py-4">{{ Lang.get('js.premise.empty') }}</p>
        </div>

    </div>
</template>

<script>
    import PremisePagePreview from './PremisePagePreview';
    import Blazy from 'blazy';

    export default {
        name: "main-page-premise-pages",
        props: {
            premisesStatuses: {
                required: true,
            }, premisesType: {
                required: true,
            },
        },
        components: {
            PremisePagePreview
        },
        data() {
            return {
                activeFiltr: false,
                status: 'all',
                type: '',
                data: {},
                loading: false,
                fullSearchShow: false,
                Lang,
                districtOptions: [],
                stationOptions: [],
                filters: {
                    price_sorting: '',
                    price_from: '',
                    price_to: '',
                    area_from: '',
                    area_to: '',
                    district: '',
                    station: '',
                    my_type: '',
                    my_status: '',
                },
                price_options: [
                    {
                        id: 1,
                        value: 'desc',
                        label: 'От дорогих к дешевым',
                    },
                    {
                        id: 2,
                        value: 'asc',
                        label: 'От дешевых к дорогим',
                    },
                ],
                type_options_ua: [
                    {
                        id: 1,
                        value: 'Продаж',
                    },
                    {
                        id: 2,
                        value: 'Оренда',
                    },
                ],
                type_options_ru: [
                    {
                        id: 1,
                        value: 'Продажа',
                    },
                    {
                        id: 2,
                        value: 'Аренда',
                    },
                ],
            }
        },
        watch: {
            // filters: {
            //     handler: _.debounce(
            //         function () {
            //             this.getPremisePages(this.status);
            //         }, 500
            //     ),
            //     deep: true
            // },
            status: {
                handler: _.debounce(
                    function () {
                        this.getPremisePages(this.status);
                    }, 500
                ),
                deep: true
            },
        },
        computed: {
            preparedPriceOptionsList() {
              if(Lang.locale == 'ru') {
                 return [
                      {
                          id: 1,
                          value: 'desc',
                          label: 'От дорогих к дешевым',
                      },
                      {
                          id: 2,
                          value: 'asc',
                          label: 'От дешевых к дорогим',
                      },
                  ]
              }  else {
                  return [
                      {
                          id: 1,
                          value: 'desc',
                          label: 'Від дорогих до дешевих',
                      },
                      {
                          id: 2,
                          value: 'asc',
                          label: 'Від дешевих до дорогих',
                      },
                  ]
              }
            },
            premiseTypeOptions() {
                if (Lang.locale == 'ua') {
                    return this.type_options_ua;
                } else {
                    return this.type_options_ru;
                }
            },
            preparedPremiseTypes() {
                let filteredTypes = this.premiseTypesList;
                return filteredTypes.filter(item => item.language === this.defaultLanguage);

            },
            preparedPremiseStatuses() {
                let filteredStatuses = this.premiseStatusesList;
                return filteredStatuses.filter(item => item.language === this.defaultLanguage);
            },
            areaVariations() {
                let variations = [];
                let key = 0;
                let variation = '';
                for (var i = 10; i <= 2000; i = i + 10) {
                    variation = {
                        id: key + 1,
                        value: i
                    };
                    key = key + 1;
                    variations.push(variation);
                }

                return variations;
            },
        },
        methods: {
            showFiltres() {
                this.classFiltr = 'all';
            },
            clearFilters() {
                this.filters.price_sorting = '';
                this.filters.price_from = '';
                this.filters.price_to = '';
                this.filters.area_from = '';
                this.filters.area_to = '';
                this.filters.district = '';
                this.filters.my_type = '';
                this.filters.my_status = '';
                this.filters.station = '';
                this.status = 'all';
            },
            getPremisePages(status, type) {

                // this.status = status;
                // if (this.type == type) {
                //     this.type = '';
                //     type = '';
                // } else {
                //     this.type = type;
                // }

                this.loading = true;
                let url = '';
                if (Lang.locale == 'ru') {
                    url = '/ru/get-premise-pages-by-status';
                } else {
                    url = '/get-premise-pages-by-status';
                }

                axios.post(url, {
                    status: this.status,
                    language: Lang.locale,
                    type: this.type,
                    price_sorting: this.filters.price_sorting,
                    price_from: this.filters.price_from,
                    price_to: this.filters.price_to,
                    area_from: this.filters.area_from,
                    area_to: this.filters.area_to,
                    district: this.filters.district,
                    station: this.filters.station,
                    my_type: this.filters.my_type,
                    my_status: this.filters.my_status,
                }).then(res => {
                    this.data = res.data.premises;
                    this.districtOptions = res.data.districts_options;
                    this.stationOptions = res.data.stations_options;
                    this.loading = false;
                    this.fullSearchShow = false;

                    setTimeout(function () {
                        let bLazy = new Blazy();
                    }, 100);
                }).catch(err => console.log(err));
            },

            setClassActive(status) {
                return this.status === status ? 'selected-item' : '';
            },
            setClassActiveDistrict(district) {
                return this.filters.district == district ? 'selected-item' : '';
            },
            setDistrictElement(district) {
                this.filters.district = district;
            },
            setStationElement(station) {
                this.filters.station = station;
            },
            setMyTypeElement(elem) {
                this.filters.my_type = elem;
            },
            // setMyStatusElement(elem) {
            //     this.filters.my_status = elem;
            // },
            setClassActiveStation(station) {
                return this.filters.station == station ? 'selected-item' : '';
            },
            setClassActiveType(type) {
                return this.filters.my_type == type ? 'selected-item' : '';
            },
        },
        mounted() {
            this.getPremisePages(this.status);

        }
    }
</script>

<style scoped>
    .selected-item {
        color: #0000cc;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/premise/MainPagePremisePages.vue